import { useEffect, useState } from "react";
import { Panel } from "@/platform/ui";

// The Alpha with AI model portfolio, live from Datawrapper (chart gaSYC). The address carries no version, so the page
// always shows the latest publish; the chart reports its own height, which the frame follows, as Datawrapper's
// embed script does. greeksoup.ai's portfolio performance embed replaces this when it ships (26 Oct 2026).
const ID = "gaSYC";
const SRC = `https://datawrapper.dwcdn.net/${ID}/`;

export const PortfolioChart = () => {
  const [h, setH] = useState(527);
  useEffect(() => {
    const on = (e: MessageEvent) => {
      if (e.origin !== "https://datawrapper.dwcdn.net") return;
      const got = (e.data as { "datawrapper-height"?: Record<string, number> } | null)?.["datawrapper-height"]?.[ID];
      if (typeof got === "number" && got > 100) setH(got);
    };
    window.addEventListener("message", on);
    return () => window.removeEventListener("message", on);
  }, []);
  return (
    <figure className="m-0">
      <Panel className="overflow-hidden">
        <iframe title="Alpha with AI portfolio" aria-label="Line chart" src={SRC} scrolling="no" loading="lazy"
          className="block w-full border-0" style={{ height: h }} />
      </Panel>
      <figcaption className="mt-2 text-[12.5px] leading-[1.55] text-muted-foreground">
        The model book since it opened on 8 July 2026, against the S&amp;P 500, updated after each US market close. Inside the Club, the Coverage
        tab dates and prices every position the day it entered.
      </figcaption>
    </figure>
  );
};
